import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IHelpQuestion } from '@verzekeringapp-mono/shared/src/models/help_question'
import React, { useState } from 'react'

interface IProps {
  question: IHelpQuestion
}

const HelpQuestionToggle: React.FC<IProps> = props => {
  const [showMoreInfo, setShowMoreInfo] = useState(false)
  const { question } = props

  return (
    <div>
      <div
        key={props.question.id}
        onClick={() => setShowMoreInfo(!showMoreInfo)}
        className='flex flex-row mt-8 justify-between items-start font-medium cursor-pointer'
      >
        <p className='font-medium'>{question.text}</p>

        <button className='ml-8 flex h-[40px] w-[40px] aspect-square items-center justify-center rounded-full bg-surface-brand-subtle'>
          <FontAwesomeIcon
            icon='plus'
            size='lg'
            className='text-icon-brand'
          />
        </button>
      </div>

      {showMoreInfo && <div className='mt-2 font-light'>{question.answer}</div>}
    </div>
  )
}

export default HelpQuestionToggle
